module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(2), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(3), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(4), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(5), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(6), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(7), _inherits3 = _interopRequireDefault(_inherits2), _freeze = __webpack_require__(8), _freeze2 = _interopRequireDefault(_freeze), _classnames = __webpack_require__(9), _classnames2 = _interopRequireDefault(_classnames), _styles = __webpack_require__(10), _styles2 = _interopRequireDefault(_styles), _react = __webpack_require__(14), _react2 = _interopRequireDefault(_react), SPINNER_SIZE = 20, SPINNER_DELAY = 100, SIZES = (0, 
    _freeze2.default)({
        small: 20,
        medium: 30,
        large: 50,
        xlarge: 100
    }), Spinner = function(_PureComponent) {
        function Spinner() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, Spinner);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Spinner.__proto__ || (0, 
            _getPrototypeOf2.default)(Spinner)).call.apply(_ref, [ this ].concat(args))), _this.state = {
                spinnerHiddenForDelay: !0,
                spinnerDelayTimeout: null
            }, _this.showSpinnerAfterDelay = function() {
                _this.state.spinnerDelayTimeout && clearTimeout(_this.state.spinnerDelayTimeout), 
                _this.setState({
                    spinnerDelayTimeout: setTimeout(_this.handleSpinnerDelayEnd, SPINNER_DELAY),
                    spinnerHiddenForDelay: !0
                });
            }, _this.handleSpinnerDelayEnd = function() {
                _this.setState({
                    spinnerHiddenForDelay: !1
                });
            }, _this.handleTransitionEnd = function(e) {
                // we have to check that props.isCompleting as a transitionEnd event will be fired when starting
                // up and winding down. This could lead to a case where a spinner starts completing and is then
                // sets isCompleting="false" in which case onComplete will not be called, which is expected
                // behaviour (the transition did not complete).
                "stroke-dashoffset" === e.propertyName && _this.props.isCompleting && _this.props.onComplete();
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(Spinner, _PureComponent), (0, _createClass3.default)(Spinner, [ {
            key: "componentDidMount",
            value: function() {
                this.props.isCompleting || this.showSpinnerAfterDelay();
            }
        }, {
            key: "componentWillReceiveProps",
            value: function(nextProps) {
                // if we werent displaying the spinner and now we are
                this.props.isCompleting && !nextProps.isCompleting && this.showSpinnerAfterDelay();
            }
        }, {
            key: "componentWillUnmount",
            value: function() {
                this.state.spinnerDelayTimeout && clearTimeout(this.state.spinnerDelayTimeout);
            }
        }, {
            key: "render",
            value: function() {
                var _spinnerStyles, spinnerSize = SIZES[this.props.size] || this.props.size;
                "number" != typeof spinnerSize && (spinnerSize = SPINNER_SIZE);
                var spinnerStyles = (_spinnerStyles = {}, (0, _defineProperty3.default)(_spinnerStyles, _styles2.default.spinner, !0), 
                (0, _defineProperty3.default)(_spinnerStyles, _styles2.default.hidden, this.state.spinnerHiddenForDelay), 
                (0, _defineProperty3.default)(_spinnerStyles, _styles2.default.active, !this.props.isCompleting), 
                _spinnerStyles), strokeWidth = Math.round(spinnerSize / 10), strokeRadius = spinnerSize / 2 - strokeWidth / 2, circumference = Math.PI * strokeRadius * 2, dashStyles = {
                    strokeDashoffset: this.props.isCompleting ? circumference : .8 * circumference,
                    strokeDasharray: circumference
                };
                return _react2.default.createElement("div", {
                    style: {
                        display: "inline-flex"
                    }
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(spinnerStyles),
                    onTransitionEnd: this.handleTransitionEnd,
                    style: {
                        height: spinnerSize + "px",
                        width: spinnerSize + "px"
                    }
                }, _react2.default.createElement("div", {
                    className: _styles2.default.spinnerWrapper
                }, _react2.default.createElement("svg", {
                    height: spinnerSize,
                    width: spinnerSize,
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 " + spinnerSize + " " + spinnerSize
                }, _react2.default.createElement("circle", {
                    className: _styles2.default.circle,
                    fill: "none",
                    strokeWidth: strokeWidth,
                    strokeLinecap: "round",
                    cx: spinnerSize / 2,
                    cy: spinnerSize / 2,
                    r: strokeRadius,
                    style: dashStyles
                })))));
            }
        } ]), Spinner;
    }(_react.PureComponent);
    Spinner.displayName = "AkSpinner", Spinner.propTypes = {
        onComplete: _react.PropTypes.func,
        isCompleting: _react.PropTypes.bool,
        size: _react2.default.PropTypes.oneOfType([ _react2.default.PropTypes.number, _react2.default.PropTypes.oneOf([ "small", "medium", "large", "xlarge" ]) ])
    }, Spinner.defaultProps = {
        onComplete: function() {},
        isCompleting: !1,
        size: "small"
    }, exports.default = Spinner;
}, /* 2 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/defineProperty");
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/freeze");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("classnames");
}, /* 10 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(11);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(13)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 11 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(12)(), // imports
    // module
    exports.push([ module.id, "._2QF5HCMDMMqHB10Xavjq6D{-webkit-animation:FCepY8CTy8A--P-cG--RM .53s ease-in-out;animation:FCepY8CTy8A--P-cG--RM .53s ease-in-out;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}._1FChkZKMZMx6vRyjCraolj{-webkit-animation:_1dV2oYNp5TLP-TeFYWn9qU .86s infinite;animation:_1dV2oYNp5TLP-TeFYWn9qU .86s infinite;-webkit-animation-timing-function:cubic-bezier(.4,.15,.6,.85);animation-timing-function:cubic-bezier(.4,.15,.6,.85);display:-webkit-inline-box;display:inline-flex}._2QF5HCMDMMqHB10Xavjq6D ._3QSyePwZJKwIi8dkRv0FSM{-webkit-transition:stroke-dashoffset .8s ease-in-out,opacity .2s ease-in-out .45s;transition:stroke-dashoffset .8s ease-in-out,opacity .2s ease-in-out .45s;opacity:0;-webkit-transform-origin:center;transform-origin:center;stroke:#42526e}._2QF5HCMDMMqHB10Xavjq6D._1TQLETw_kTVmwOsNwtReTs{opacity:0}._2QF5HCMDMMqHB10Xavjq6D._1CUu13e6LPJtty81jNdywj{-webkit-animation:_17EedLRca-qJulQLjX2R8s 1s ease-in-out forwards;animation:_17EedLRca-qJulQLjX2R8s 1s ease-in-out forwards}._2QF5HCMDMMqHB10Xavjq6D._1CUu13e6LPJtty81jNdywj ._3QSyePwZJKwIi8dkRv0FSM{opacity:1;-webkit-transition:stroke-dashoffset .8s ease-in-out,opacity .2s ease-in-out;transition:stroke-dashoffset .8s ease-in-out,opacity .2s ease-in-out}@-webkit-keyframes _1dV2oYNp5TLP-TeFYWn9qU{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes _1dV2oYNp5TLP-TeFYWn9qU{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes _17EedLRca-qJulQLjX2R8s{0%{-webkit-transform:rotate(50deg);transform:rotate(50deg)}to{-webkit-transform:rotate(230deg);transform:rotate(230deg)}}@keyframes _17EedLRca-qJulQLjX2R8s{0%{-webkit-transform:rotate(50deg);transform:rotate(50deg)}to{-webkit-transform:rotate(230deg);transform:rotate(230deg)}}@-webkit-keyframes FCepY8CTy8A--P-cG--RM{0%{-webkit-transform:rotate(230deg);transform:rotate(230deg)}to{-webkit-transform:rotate(510deg);transform:rotate(510deg)}}@keyframes FCepY8CTy8A--P-cG--RM{0%{-webkit-transform:rotate(230deg);transform:rotate(230deg)}to{-webkit-transform:rotate(510deg);transform:rotate(510deg)}}", "" ]), 
    // exports
    exports.locals = {
        spinner: "_2QF5HCMDMMqHB10Xavjq6D",
        spinner: "_2QF5HCMDMMqHB10Xavjq6D",
        spinnerLoad: "FCepY8CTy8A--P-cG--RM",
        spinnerLoad: "FCepY8CTy8A--P-cG--RM",
        "spinner-wrapper": "_1FChkZKMZMx6vRyjCraolj",
        spinnerWrapper: "_1FChkZKMZMx6vRyjCraolj",
        spinnerSpin: "_1dV2oYNp5TLP-TeFYWn9qU",
        spinnerSpin: "_1dV2oYNp5TLP-TeFYWn9qU",
        circle: "_3QSyePwZJKwIi8dkRv0FSM",
        circle: "_3QSyePwZJKwIi8dkRv0FSM",
        hidden: "_1TQLETw_kTVmwOsNwtReTs",
        hidden: "_1TQLETw_kTVmwOsNwtReTs",
        active: "_1CUu13e6LPJtty81jNdywj",
        active: "_1CUu13e6LPJtty81jNdywj",
        spinnerLoad2: "_17EedLRca-qJulQLjX2R8s",
        spinnerLoad2: "_17EedLRca-qJulQLjX2R8s"
    };
}, /* 12 */
/***/
function(module, exports) {
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    // css base code, injected by the css-loader
    module.exports = function() {
        var list = [];
        // return the list of modules as css string
        // import a list of modules into the list
        return list.toString = function() {
            for (var result = [], i = 0; i < this.length; i++) {
                var item = this[i];
                item[2] ? result.push("@media " + item[2] + "{" + item[1] + "}") : result.push(item[1]);
            }
            return result.join("");
        }, list.i = function(modules, mediaQuery) {
            "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
            for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                var id = this[i][0];
                "number" == typeof id && (alreadyImportedModules[id] = !0);
            }
            for (i = 0; i < modules.length; i++) {
                var item = modules[i];
                // skip already imported module
                // this implementation is not 100% perfect for weird media query combinations
                //  when a module is imported multiple times with different media queries.
                //  I hope this will never occur (Hey this way we have smaller bundles)
                "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                list.push(item));
            }
        }, list;
    };
}, /* 13 */
/***/
function(module, exports, __webpack_require__) {
    function addStylesToDom(styles, options) {
        for (var i = 0; i < styles.length; i++) {
            var item = styles[i], domStyle = stylesInDom[item.id];
            if (domStyle) {
                domStyle.refs++;
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
                for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j], options));
            } else {
                for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j], options));
                stylesInDom[item.id] = {
                    id: item.id,
                    refs: 1,
                    parts: parts
                };
            }
        }
    }
    function listToStyles(list) {
        for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
            var item = list[i], id = item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
                css: css,
                media: media,
                sourceMap: sourceMap
            };
            newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
                id: id,
                parts: [ part ]
            });
        }
        return styles;
    }
    function insertStyleElement(options, styleElement) {
        var head = getHeadElement(), lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
        if ("top" === options.insertAt) lastStyleElementInsertedAtTop ? lastStyleElementInsertedAtTop.nextSibling ? head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling) : head.appendChild(styleElement) : head.insertBefore(styleElement, head.firstChild), 
        styleElementsInsertedAtTop.push(styleElement); else {
            if ("bottom" !== options.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
            head.appendChild(styleElement);
        }
    }
    function removeStyleElement(styleElement) {
        styleElement.parentNode.removeChild(styleElement);
        var idx = styleElementsInsertedAtTop.indexOf(styleElement);
        idx >= 0 && styleElementsInsertedAtTop.splice(idx, 1);
    }
    function createStyleElement(options) {
        var styleElement = document.createElement("style");
        return styleElement.type = "text/css", insertStyleElement(options, styleElement), 
        styleElement;
    }
    function createLinkElement(options) {
        var linkElement = document.createElement("link");
        return linkElement.rel = "stylesheet", insertStyleElement(options, linkElement), 
        linkElement;
    }
    function addStyle(obj, options) {
        var styleElement, update, remove;
        if (options.singleton) {
            var styleIndex = singletonCounter++;
            styleElement = singletonElement || (singletonElement = createStyleElement(options)), 
            update = applyToSingletonTag.bind(null, styleElement, styleIndex, !1), remove = applyToSingletonTag.bind(null, styleElement, styleIndex, !0);
        } else obj.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (styleElement = createLinkElement(options), 
        update = updateLink.bind(null, styleElement), remove = function() {
            removeStyleElement(styleElement), styleElement.href && URL.revokeObjectURL(styleElement.href);
        }) : (styleElement = createStyleElement(options), update = applyToTag.bind(null, styleElement), 
        remove = function() {
            removeStyleElement(styleElement);
        });
        return update(obj), function(newObj) {
            if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                update(obj = newObj);
            } else remove();
        };
    }
    function applyToSingletonTag(styleElement, index, remove, obj) {
        var css = remove ? "" : obj.css;
        if (styleElement.styleSheet) styleElement.styleSheet.cssText = replaceText(index, css); else {
            var cssNode = document.createTextNode(css), childNodes = styleElement.childNodes;
            childNodes[index] && styleElement.removeChild(childNodes[index]), childNodes.length ? styleElement.insertBefore(cssNode, childNodes[index]) : styleElement.appendChild(cssNode);
        }
    }
    function applyToTag(styleElement, obj) {
        var css = obj.css, media = obj.media;
        if (media && styleElement.setAttribute("media", media), styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
            for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
            styleElement.appendChild(document.createTextNode(css));
        }
    }
    function updateLink(linkElement, obj) {
        var css = obj.css, sourceMap = obj.sourceMap;
        sourceMap && (// http://stackoverflow.com/a/26603875
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */");
        var blob = new Blob([ css ], {
            type: "text/css"
        }), oldSrc = linkElement.href;
        linkElement.href = URL.createObjectURL(blob), oldSrc && URL.revokeObjectURL(oldSrc);
    }
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    var stylesInDom = {}, memoize = function(fn) {
        var memo;
        return function() {
            return "undefined" == typeof memo && (memo = fn.apply(this, arguments)), memo;
        };
    }, isOldIE = memoize(function() {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
    }), getHeadElement = memoize(function() {
        return document.head || document.getElementsByTagName("head")[0];
    }), singletonElement = null, singletonCounter = 0, styleElementsInsertedAtTop = [];
    module.exports = function(list, options) {
        options = options || {}, // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
        // tags it will allow on a page
        "undefined" == typeof options.singleton && (options.singleton = isOldIE()), // By default, add <style> tags to the bottom of <head>.
        "undefined" == typeof options.insertAt && (options.insertAt = "bottom");
        var styles = listToStyles(list);
        return addStylesToDom(styles, options), function(newList) {
            for (var mayRemove = [], i = 0; i < styles.length; i++) {
                var item = styles[i], domStyle = stylesInDom[item.id];
                domStyle.refs--, mayRemove.push(domStyle);
            }
            if (newList) {
                var newStyles = listToStyles(newList);
                addStylesToDom(newStyles, options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
                var domStyle = mayRemove[i];
                if (0 === domStyle.refs) {
                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                    delete stylesInDom[domStyle.id];
                }
            }
        };
    };
    var replaceText = function() {
        var textStore = [];
        return function(index, replacement) {
            return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
        };
    }();
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("react");
} ]);


//////////////////
// WEBPACK FOOTER
// ../field-text/~/@atlaskit/spinner/dist/bundle-cjs.js
// module id = 464
// module chunks = 0